import React from 'react';

export default function Card({ children, className = '' }) {
    return (
        <div className={`card-header flex-wrap p-4 d-flex align-items-start mb-3 ${className}`}>
            {children}
        </div>
    )
}